import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from 'primeng/autocomplete';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AirportService } from 'src/app/trip-calculator/services/airport.service';
import { Airport } from 'src/app/trip-calculator/models/airport';
import { Subscription } from 'rxjs';
import { ErrorComponent } from '../../../error/error.component';

@Component({
  selector: 'app-select-airport',
  imports: [
    AutoCompleteModule,
    TranslocoPipe,
    FormsModule,
    ReactiveFormsModule,
    ErrorComponent,
  ],
  templateUrl: './select-airport.component.html',
})
export class SelectAirportComponent implements OnInit {
  airportService = inject(AirportService);
  translocoService = inject(TranslocoService);
  @Input() placeholder!: string;
  @Input() isTransit: boolean = false;
  @Input() index?: number;
  @Input() formGroup!: FormGroup;
  @Output() delete = new EventEmitter<number>();
  filteredAirports: Airport[] = [];
  selectedAirport?: Airport;
  valueChangeSubscription?: Subscription;

  ngOnInit(): void {
    const code = this.formGroup.get('airportCode')?.value;
    if (code) {
      this.airportService.searchAirports(code).subscribe((airports) => {
        const airport = airports.find((a) => a.Code === code);
        if (airport) {
          this.selectedAirport = {
            ...airport,
            label: this.getTranslatedAirportLabel(airport),
          };
        }
      });
    }
  }
  handleSelect(event: AutoCompleteSelectEvent) {
    const code = event.value.Code;
    this.formGroup.get('airportCode')?.setValue(code);
  }
  getTranslatedAirportLabel(airport: Airport) {
    const lang = this.translocoService.getActiveLang();
    switch (lang) {
      case 'fr':
        return `${airport.Code} - ${airport.CityFR} (${airport.MainCityFR})`;
      case 'nl':
        return `${airport.Code} - ${airport.CityNL} (${airport.MainCityNL})`;
      default:
        return `${airport.Code} - ${airport.City} (${airport.MainCity})`;
    }
  }

  filterAirports(event: AutoCompleteCompleteEvent): void {
    const query = event.query;
    this.airportService.searchAirports(query).subscribe((airports) => {
      this.filteredAirports = airports.map((airport) => ({
        ...airport,
        label: this.getTranslatedAirportLabel(airport),
      }));
    });
  }
  onDelete(): void {
    this.delete.emit(this.index);
  }
}
